const IconLogoShort = (props) => (
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M0 0.729248C13.8095 0.729248 25 10.9427 25 23.5466H0V0.729248Z'
      fill='currentColor'
    />
  </svg>
)

export default IconLogoShort
